/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"
import { CookiesProvider } from 'react-cookie';

import HeaderBanner from "./header-banner"
import HeaderMain from "./header-main"
import Pros from "./pros"
import Footer from "./footer"
import StickyBanner from "./sticky-banner"
import Loaded from "./loaded"

import "../css/normalize.css"
import "../css/style.sass"
import "../css/posts.sass"

const Layout = ({ showMagazineMainNav, children }) => {
  return (
    <CookiesProvider>
      <HeaderBanner />
      <HeaderMain />
      {children}
      <Pros />
      <Footer />
      <StickyBanner />
      <Loaded />
    </CookiesProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
